export const INCREASE_ROUND = 'INCREASE_ROUND';
export const DECREASE_ROUND = 'DECREASE_ROUND';
export const INCREASE_WILDLING_THREAT = 'INCREASE_WILDLING_THREAT';
export const DECREASE_WILDLING_THREAT = 'DECREASE_WILDLING_THREAT';
export const RESET_GAME = 'RESET_GAME';
